export const SELECTED_USER_CHAT_ID = null;
export const SELECTED_SERVICE_PROVIDER_CHAT_ID = null;